<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { audioManager } from '../../utils/audioManager'
import { QuizAudioKey } from '../../types/quiz'
import winning from '../../assets/audios/winning.mp3'
const show = ref(false)
onMounted(() => {
    audioManager.play(winning, QuizAudioKey.SFX)
    show.value = true
    setTimeout(() => { show.value = false }, 3500)
})
</script>

<template>
    <Transition :duration="1000" name="nested">
        <div v-if="show"
            class="outer w-full h-1/4 flex justify-center items-center bg-purple-800 text-2xl md:text-4xl font-bold border">
            <div class="inner">
                <slot></slot>
            </div>
        </div>
    </Transition>
</template>

<style scoped>
.nested-enter-active {
    animation-name: scale;
    animation-duration: 0.3s;
    animation-timing-function: ease-in-out;
    animation-fill-mode: both;
}

.nested-leave-active {
    animation-name: scale;
    animation-duration: 0.3s;
    animation-timing-function: ease-in-out;
    animation-delay: 0.7s;
    animation-fill-mode: both;
    animation-direction: reverse;
}

.nested-enter-active .inner {
    animation-name: slide-in-elliptic-left-fwd;
    animation-duration: 0.7s;
    animation-timing-function: cubic-bezier(0.250, 0.460, 0.450, 0.940);
    animation-delay: 0.3s;
    animation-fill-mode: both;
}

.nested-leave-active .inner {
    animation-name: slide-out-elliptic-right-bck;
    animation-duration: 0.7s;
    animation-timing-function: cubic-bezier(0.250, 0.460, 0.450, 0.940);
    animation-fill-mode: both;
}

@keyframes scale {
    0% {
        transform: scale(0.5);
        opacity: 0;
    }

    100% {
        transform: scale(1);
        opacity: 1;
    }
}


@keyframes slide-in-elliptic-left-fwd {
    0% {
        transform: translateX(-800px) rotateY(30deg) scale(0);
        transform-origin: -100% 50%;
        opacity: 0;
    }

    100% {
        transform: translateX(0) rotateY(0) scale(1);
        transform-origin: 1800px 50%;
        opacity: 1;
    }
}

@keyframes slide-out-elliptic-right-bck {
    0% {
        transform: translateX(0) rotateY(0) scale(1);
        transform-origin: -1800px 50%;
        opacity: 1;
    }

    100% {
        transform: translateX(800px) rotateY(-30deg) scale(0);
        transform-origin: -100% 50%;
        opacity: 0;

    }
}
</style>